import { HttpClient } from '@angular/common/http';
import {
  EnvironmentProviders,
  inject,
  Injectable,
  isDevMode,
  makeEnvironmentProviders,
} from '@angular/core';
import {
  Translation,
  TranslocoLoader,
  provideTransloco,
} from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly _http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this._http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

export const DEFAULT_LANGUAGE = 'en';

export const AVAILABLE_LANGUAGES = [
  // Quality certified on backend
  'en', // English
  'es', // Spanish
  'fr', // French
  'de', // German
  'it', // Italian
  'pt', // Portuguese
  'zh', // Chinese
  'ja', // Japanese
  'ko', // Korean
  'ar', // Arabic
  'nl', // Dutch
  'ru', // Russian
  'hi', // Hindi
  'sv', // Swedish
  'no', // Norwegian
  'da', // Danish
  'el', // Greek
  // Not yet quality certified on backend
  'pl', // Polish
  'tr', // Turkish
  'vi', // Vietnamese
  'th', // Thai
  'id', // Indonesian
  'ms', // Malay
  'he', // Hebrew
  // Locale variants + additional languages with i18n files
  'fr-ca', // French Canadian
  'en-au', // Australian English
  'cs', // Czech
  'hr', // Croatian
  'hu', // Hungarian
  'sk', // Slovak
  'sl', // Slovenian
  'fi', // Finnish
];

export function provideTranslocoConfig(): EnvironmentProviders {
  return makeEnvironmentProviders(
    provideTransloco({
      config: {
        availableLangs: AVAILABLE_LANGUAGES,
        defaultLang: DEFAULT_LANGUAGE,
        fallbackLang: DEFAULT_LANGUAGE,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          useFallbackTranslation: true,
        },
      },
      loader: TranslocoHttpLoader,
    }) as any
  );
}
